var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF055") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0000129,7.85713673 L11.0000129,6.71427822 C11.0000129,6.40177785 10.7410841,6.14284897 10.4285837,6.14284897 L8.14286668,6.14284897 L8.14286668,3.85713196 C8.14286668,3.54463159 7.8839378,3.28570271 7.57143743,3.28570271 L6.42857892,3.28570271 C6.11607855,3.28570271 5.85714967,3.54463159 5.85714967,3.85713196 L5.85714967,6.14284897 L3.57143266,6.14284897 C3.25893229,6.14284897 3.00000341,6.40177785 3.00000341,6.71427822 L3.00000341,7.85713673 C3.00000341,8.1696371 3.25893229,8.42856598 3.57143266,8.42856598 L5.85714967,8.42856598 L5.85714967,10.714283 C5.85714967,11.0267834 6.11607855,11.2857122 6.42857892,11.2857122 L7.57143743,11.2857122 C7.8839378,11.2857122 8.14286668,11.0267834 8.14286668,10.714283 L8.14286668,8.42856598 L10.4285837,8.42856598 C10.7410841,8.42856598 11.0000129,8.1696371 11.0000129,7.85713673 Z M13.8571592,7.28570747 C13.8571592,11.0714263 10.785727,14.1428585 7.00000817,14.1428585 C3.21428938,14.1428585 0.142857143,11.0714263 0.142857143,7.28570747 C0.142857143,3.49998868 3.21428938,0.428556442 7.00000817,0.428556442 C10.785727,0.428556442 13.8571592,3.49998868 13.8571592,7.28570747 Z",
    id: "\\uF055",
    fill: "#4095A8",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.82853ed557958808df8d012b36b2ce11.svg";
export { ForwardRef as ReactComponent };